module.exports = __webpack_public_path__ + "media/customizations/paintedtree/back-3d7eed2d9cb82e4654d76000a830bc84.jpg";